module.exports = __webpack_public_path__ + "img/24.2d65e30c.jpg";